export const skipNodes = [
    "ABBR",
    "BUTTON",
    "CODE",
    "IFRAME",
    "INPUT",
    "META",
    "SCRIPT",
    "STYLE",
    "TEXTAREA",
    "TIME",
    "VAR"
];
//# sourceMappingURL=skip_nodes.js.map